/*  ========================================================================
    # Scripts - Simple Hero
    ========================================================================  */

const SimpleHero = {
  cfg: {
    simpleHeroSections: document.querySelectorAll('.s-simple-hero--video')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.simpleHeroSections.forEach(entry => {
      const videoContainer = entry.querySelector('.s-simple-hero__video');
      const videoDialog = entry.querySelector('.c-dialog');

      // click on the video container to open the dialog
      videoContainer.addEventListener('click', () => {
        videoDialog.showModal();
        videoDialog.classList.add('c-dialog--active');
        videoDialog.querySelector('video').play();
      });

      const videoDialogClose = entry.querySelector('.c-dialog__close');

      // click on the Close button to close the dialog and pause the video
      videoDialogClose.addEventListener('click', () => {
        videoDialog.close();
      });

      videoDialog.addEventListener('close', () => {
        videoDialog.classList.remove('c-dialog--active');
        videoDialog.querySelector('video').pause();
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.simpleHeroSections.length > 0) this.handler();
  }
};

export default SimpleHero;
